import Form, { ButtonItem, ButtonOptions, Item } from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import { TextBoxTypes } from "devextreme-react/text-box";
import { RequiredRule } from "devextreme-react/validator";
import notify from "../../lib/notify";
import React, { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { twoFaLogin } from "../../api/auth";
import { useAuth } from "../../contexts/auth";
import "./TwoFaLoginForm.scss";

type TwoFaLoginFormProps = {
  recoveryLink?: string;
  rememberMe?: boolean;
};

export const TwoFaLoginForm = ({
  recoveryLink = "/recovery-code-login",
  rememberMe = false,
}: TwoFaLoginFormProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signInAuth } = useAuth();
  const formData = useRef({ code: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setLoading(true);
      const { code } = formData.current;
      const result = await twoFaLogin(code, rememberMe);
      setLoading(false);

      if (result.isOk) {
        await signInAuth();
        navigate("/");
      } else {
        notify(result.error || t("common.unknownErrorOccurred"), "error", 5000);
      }
    },
    [navigate, signInAuth],
  );

  return (
    <form className="twofa-login-form" onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField="code"
          editorOptions={
            {
              // mask: "000000",
              // showMaskMode: "onFocus",
              stylingMode: "filled",
              placeholder: t("Code"),
              maxLength: 6,
            } as TextBoxTypes.Properties
          }
          label={{
            visible: false,
          }}
        >
          <RequiredRule />
        </Item>
        <ButtonItem>
          <ButtonOptions width="100%" type="default" useSubmitBehavior>
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width="24px" height="24px" visible />
              ) : (
                t("submit")
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <div className="two-fa-link">
        {t("You don't have access to your device?")}{" "}
        <Link to={recoveryLink}>{t("Use recovery code")}</Link>
      </div>
    </form>
  );
};
